<script setup lang="ts">
    import { HolidayPayObligationEntry } from '@/types';
    import { HoverCardContent, HoverCardPortal, HoverCardRoot, HoverCardTrigger } from 'reka-ui';
    import DataTableCurrency from '@/components/datatable/DataTableCurrency.vue';
    import { formatCurrency } from '@/utils/helpers';
    import { useI18n } from 'vue-i18n';
    import { computed } from 'vue';

    const { t } = useI18n();

    const props = defineProps<{
        value: number;
        holidayPayObligationEntry: HolidayPayObligationEntry;
    }>();

    const caculation = computed(() => {
        return [
            {
                trans: t('holiday-pay-obligations.entries.tooltip.basic_salary.salary'),
                amount: formatCurrency(
                    props.holidayPayObligationEntry.calculator.basic_salary.salary,
                ),
            },
            {
                trans: t('holiday-pay-obligations.entries.tooltip.basic_salary.fixed_add_ons'),
                amount: formatCurrency(
                    Number(props.holidayPayObligationEntry.calculator.basic_salary.fixed_add_ons),
                ),
            },
            {
                trans: t('holiday-pay-obligations.entries.tooltip.basic_salary.company_pension'),
                amount: formatCurrency(
                    props.holidayPayObligationEntry.calculator.basic_salary.company_pension,
                ),
            },
            {
                trans: t('holiday-pay-obligations.entries.tooltip.basic_salary.free_car_monthly'),
                amount: formatCurrency(
                    props.holidayPayObligationEntry.calculator.basic_salary.free_car_monthly,
                ),
            },
            {
                trans: t('holiday-pay-obligations.entries.tooltip.basic_salary.free_phone_monthly'),
                amount: formatCurrency(
                    props.holidayPayObligationEntry.calculator.basic_salary.free_phone_monthly,
                ),
            },
            {
                trans: t(
                    'holiday-pay-obligations.entries.tooltip.basic_salary.health_insurance_monthly',
                ),
                amount: formatCurrency(
                    props.holidayPayObligationEntry.calculator.basic_salary
                        .health_insurance_monthly,
                ),
            },
            {
                trans: t('holiday-pay-obligations.entries.tooltip.basic_salary.company_atp'),
                amount: formatCurrency(
                    props.holidayPayObligationEntry.calculator.basic_salary.company_atp,
                ),
            },
        ];
    });
</script>

<template>
    <DataTableCurrency
        v-if="!holidayPayObligationEntry.calculator"
        :value="value"
        :return-zero="true"
    />
    <HoverCardRoot
        v-else
        :close-delay="0"
        :open-delay="200"
    >
        <HoverCardTrigger>
            <DataTableCurrency
                :value="value"
                :return-zero="true"
            />
        </HoverCardTrigger>
        <HoverCardPortal>
            <HoverCardContent
                class="animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 flex flex-col gap-1 rounded-xl border bg-white p-4 shadow-sm data-[state=open]:transition-all"
                :side-offset="5"
            >
                <span
                    v-for="(item, index) in caculation"
                    :key="item.trans"
                    class="text-xs"
                >
                    {{ index !== 0 ? '+' : '' }}{{ item.amount }} ({{ item.trans }})
                </span>
            </HoverCardContent>
        </HoverCardPortal>
    </HoverCardRoot>
</template>
